'use es6';

export const TOP = 'TOP';
export const BOTTOM = 'BOTTOM';